'use client'

import { Card, CardHeader, CardContent, List, Divider } from '@mui/material'
import { renderListItem } from './helpers'
import { useOutletContext } from 'react-router'

export default function PetInfo() {
	const { profile }: any = useOutletContext()

	return (
		<Card>
			<CardHeader title="Basic Info" titleTypographyProps={{ variant: 'h6' }}></CardHeader>
			<CardContent>
				<List disablePadding>
					{renderListItem('Age', `${profile?.age} ${profile?.ageContext}`)}
				</List>
				<Divider />
				{profile?.breed && (
					<>
						<List>
							{renderListItem('Breed', profile?.breed.map((b: any) => b.title).join(', '))}
						</List>
						<Divider />
					</>
				)}
				<List>{renderListItem('Gender', profile?.gender)}</List>
				<Divider />
				<List>{renderListItem('Weight', profile?.weight)}</List>
				<Divider />
				<List>
					{renderListItem(
						profile?.gender === 'male' ? 'Neutered' : 'Spayed',
						profile?.alterationStatus === 'altered' ? 'Yes' : 'No'
					)}
				</List>
			</CardContent>
		</Card>
	)
}
